<template>
    <v-bottom-sheet v-model="isEmailModalOpened" persistent v-if="user">
        <v-card>
            <v-card-title class="headline">
                {{ $t("email_confirmation") }}
                <v-spacer></v-spacer>
                <v-btn v-if="closable" color="red" icon @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div v-html="$t('we_sent_mail_to_your_email_confirm', { email: user.email })"></div>
                <div class="pb-12 pt-6">
                    <v-btn depressed class="w100" color="primary" @click="toEmail()">
                        {{ $t("to_email") }}
                    </v-btn>
                    <v-btn
                        v-if="pass"
                        depressed
                        class="w100 mt-4"
                        color="light-grey"
                        @click="close()"
                    >
                        {{ $t("skip") }}
                    </v-btn>
                </div>
            </v-card-text>
            <overlay-loader :show="isLoading"></overlay-loader>
        </v-card>
    </v-bottom-sheet>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: "VerificateEmailModal",
    components: {
        OverlayLoader,
    },
    props: ["user", "pass", "closable", "closeCallback"],
    data() {
        return {};
    },
    created() {},
    computed: {
        isLoading() {
            return this.$store.getters.AUTH_IS_LOADING;
        },
        isEmailModalOpened() {
            return this.$store.getters.IS_EMAIL_VALIDATION_OPENED;
        },
    },
    methods: {
        toEmail() {
            window.open(`//${this.user.email}`, "_blank");
        },
        close() {
            this.$store.dispatch("EMAIL_VALIDATION", false);
            if (this.closeCallback) this.closeCallback();
        },
    },
};
</script>
